import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ArticleCard from "../components/ArticleCard";
import Sidebar from "../components/Sidebar";
import {
  fetchAllPosts,
  fetchTrendingPosts,
  fetchViralPosts,
  fetchLatestPosts,
  seedPostsIfEmpty,
} from "../services/firestore";
import "./HomePage.css";

function SectionTitle({ label }) {
  return (
    <div className="section-title">
      <span className="section-title-bar" />
      <h2>{label}</h2>
    </div>
  );
}

export default function HomePage() {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";

  const [allPosts, setAllPosts] = useState([]);
  const [trending, setTrending] = useState([]);
  const [viral, setViral] = useState([]);
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      await seedPostsIfEmpty();
      const [all, trend, vir, lat] = await Promise.all([
        fetchAllPosts(),
        fetchTrendingPosts(6),
        fetchViralPosts(6),
        fetchLatestPosts(8),
      ]);
      setAllPosts(all);
      setTrending(trend);
      setViral(vir);
      setLatest(lat);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) {
    return (
      <div className="home-loading">
        <div className="loading-spinner" />
        <p>Loading latest news...</p>
      </div>
    );
  }

  // If searching, filter all posts
  if (searchQuery) {
    const q = searchQuery.toLowerCase();
    const results = allPosts.filter(
      (p) =>
        p.title?.toLowerCase().includes(q) ||
        p.excerpt?.toLowerCase().includes(q) ||
        p.category?.toLowerCase().includes(q)
    );
    return (
      <div className="container home-layout">
        <main className="home-main">
          <SectionTitle label={`Search results for "${searchQuery}"`} />
          {results.length === 0 ? (
            <p className="no-results">No articles found matching your search.</p>
          ) : (
            <div className="grid-3">
              {results.map((p) => (
                <ArticleCard key={p.id} post={p} size="medium" />
              ))}
            </div>
          )}
        </main>
        <Sidebar />
      </div>
    );
  }

  const hero = latest[0];
  const heroSecondary = latest.slice(1, 3);

  return (
    <div className="home-page">
      {/* Hero */}
      {hero && (
        <section className="hero-section">
          <div className="container">
            <div className="hero-scroll-label">Scroll Down For Latest Posts</div>
            <div className="hero-grid">
              <ArticleCard post={hero} size="large" />
              <div className="hero-secondary">
                {heroSecondary.map((p) => (
                  <ArticleCard key={p.id} post={p} size="medium" />
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Main content + Sidebar */}
      <div className="container home-layout">
        <main className="home-main">
          {/* Trending */}
          <section className="home-section">
            <SectionTitle label="Trending This Week" />
            <div className="grid-3">
              {trending.map((p) => (
                <ArticleCard key={p.id} post={p} size="medium" />
              ))}
            </div>
          </section>

          {/* Viral */}
          <section className="home-section">
            <SectionTitle label="Viral" />
            <div className="grid-3">
              {viral.map((p) => (
                <ArticleCard key={p.id} post={p} size="medium" />
              ))}
            </div>
          </section>

          {/* Latest Posts */}
          <section className="home-section">
            <SectionTitle label="Latest Posts" />
            <div className="latest-list">
              {latest.map((p) => (
                <ArticleCard key={p.id} post={p} size="medium" />
              ))}
            </div>
          </section>
        </main>

        <Sidebar />
      </div>
    </div>
  );
}
